"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
const values_1 = require("../values");
// The refrigerant side, shared by the DX coil and the condenser: CoilPro takes the same inputs
// for both and the tool sends them through the same parser. Express does not offer either, so
// there is no sweep variant here.
function propertyDefinition() {
    return [
        {
            sort_no: 70,
            name: "evaporationtemp",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 80,
            name: "condensationtemp",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 90,
            name: "subcoolingtemp",
            group: "",
            quantity: "DeltaTemperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 100,
            name: "superheattemp",
            group: "",
            quantity: "DeltaTemperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 110,
            name: "freon",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: (0, values_1.integerValues)(5)
        }
    ];
}
//# sourceMappingURL=input-definition.js.map